import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import ActionCreator from './ActionCreator';
import API from './API';

const {
  sendQuestionRequest,
  sendQuestionSuccess,
  sendQuestionFailure,

  sendQuestionFlowRequest,
  sendQuestionFlowSuccess,
  sendQuestionFlowFailure,
} = ActionCreator;

// ---------- TASKS ----------
export function* sendQuestionTask(data) {
  yield put(sendQuestionRequest(data));
  try {
    const result = yield call(API.sendUsQuestions, data);
    yield put(sendQuestionSuccess(result.data));
    return result;
  } catch (error) {
    yield put(sendQuestionFailure(error));
    throw error;
  }
}

// ---------- FLOWS ----------
export function* sendQuestionFlow({ payload }) {
  try {
    const result = yield call(sendQuestionTask, payload);
    yield put(sendQuestionFlowSuccess(result));
  } catch (error) {
    yield put(sendQuestionFlowFailure(error));
  }
}

export default [
  takeLatest(sendQuestionFlowRequest, sendQuestionFlow),
];
